var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('collapse-default'), _c('accordion-default'), _c('collapse-types'), _c('collapse-hover'), _c('collapse-boostrap-vue')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }